import { create } from 'zustand';
import { api } from '@/lib/api';
import type { HiWithSender } from '@shared/types';

interface HiState {
  his: HiWithSender[];
  loading: boolean;
  fetchHis: () => Promise<void>;
  sendHi: (userId: string) => Promise<void>;
  dismissHi: (hiId: string) => Promise<void>;
}

export const useHiStore = create<HiState>((set, get) => ({
  his: [],
  loading: false,

  fetchHis: async () => {
    if (get().loading) return;
    set({ loading: true });
    try {
      const his = await api.get<HiWithSender[]>('/his');
      set({ his, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  sendHi: async (userId: string) => {
    await api.post(`/his/${userId}`);
  },

  dismissHi: async (hiId: string) => {
    await api.del(`/his/${hiId}`);
    set({ his: get().his.filter((h) => h.id !== hiId) });
  },
}));
